import React from 'react';
import styled from 'styled-components';
import LargeCarIcon from 'icons/src/LargeCar';
import MiddleCarIcon from 'icons/src/MiddleCar';
import SmallCarIcon from 'icons/src/SmallCar';
import spacer from 'gatsby-theme-core/src/components/form-elements/spacer';

import Label from './label';
import Icon from './icon';

const Sizes = ({
  className,
  currentValue = '',
  handler,
  options = [
    {
      value: 'small',
      name: 'Klein',
      icon: SmallCarIcon,
    },
    {
      value: 'medium',
      name: 'Middel',
      icon: MiddleCarIcon,
    },
    {
      value: 'large',
      name: 'Groot',
      icon: LargeCarIcon,
    },
  ],
  withCount = false,
}) => (
  <div className={className}>
    {options.map(({
      value,
      name,
      icon,
      count,
    }) => {
      const checked = currentValue === value;
      return (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <Label
          key={name}
          $checked={checked}
        >
          <input type="checkbox" value={value} onChange={handler} />
          <Icon $checked={checked} as={icon} />
          <span>{name}{withCount && count && ` (${count})`}</span>
        </Label>
      );
    })}
  </div>
);

export default styled(Sizes)`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: .75rem;
  grid-template-columns: 1fr 1fr 1fr;
  input {
    height: 0;
    width: 0;
    overflow: hidden;
  }

  ${({ $noSpacer }) => !$noSpacer && spacer}
`;
